import styled from '@emotion/styled';

import { customPalette } from '../../../../styles/theme';

export const BannerContainer = styled.div`
  padding: 0 24px;
  display: flex;
  justify-content: flex-end;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;
export const BannerButton = styled.button`
  background-color: ${customPalette.accent.defaultGreen};
  color: ${customPalette.accent.white};
  border: none;
  padding: 18px 36px;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 14px;
  font-weight: 600;
  transition: all 0.2s ease-in-out;
  text-decoration: underline;
  text-underline-offset: 4px;
  line-height: 1.5;
  top: -100px;

  svg {
    font-size: 24px;
  }

  &:hover {
    opacity: 0.9;
  }
`;
